import * as React from "react";
import {
  List,
  DataTable,
  DateField,
  SearchInput,
  EditButton,
  ReferenceManyField,
  WithListContext,
} from "react-admin";

const ProductEventFilter = [<SearchInput source="name" alwaysOn />];

const ProductEventList = () => {
  return (
    <List title="Eventos" filters={ProductEventFilter}>
      <DataTable rowClick="show" bulkActionButtons={false}>
        <DataTable.Col source="name" label="Nombre" />
        <DataTable.Col source="fromPresale" label="Preventa desde">
          <DateField source="fromPresale" label="Preventa desde" showTime />
        </DataTable.Col>
        <DataTable.Col source="from" label="Evento desde">
          <DateField source="from" label="Evento desde" />
        </DataTable.Col>
        <DataTable.Col source="to" label="Evento hasta">
          <DateField source="to" label="Evento hasta" />
        </DataTable.Col>
        <DataTable.Col label="Productos">
          <ReferenceManyField
            reference="products"
            target="event"
            label="Productos"
            perPage={1}
          >
            <WithListContext render={({ total }) => total || 0} />
          </ReferenceManyField>
        </DataTable.Col>
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};

export default ProductEventList;
